import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export function Modal({ open, onClose, title, children }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div className="fixed inset-0 z-[80] flex items-start justify-center overflow-y-auto p-4 md:p-8" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <div className="fixed inset-0 bg-ptf-primary/60 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            data-testid="admin-modal"
            className="relative z-10 w-full max-w-2xl bg-white shadow-2xl my-8"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
          >
            <div className="flex items-center justify-between px-6 py-4 border-b border-ptf-primary/10 sticky top-0 bg-white">
              <h3 className="font-display uppercase text-2xl tracking-tight text-ptf-primary">{title}</h3>
              <button onClick={onClose} data-testid="modal-close" className="grid place-items-center h-9 w-9 hover:bg-ptf-primary/5 rounded-full"><X className="h-5 w-5" /></button>
            </div>
            <div className="p-6">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

const base = "w-full border border-ptf-primary/20 px-3 py-2.5 text-sm outline-none focus:border-ptf-secondary transition-colors bg-white text-ptf-text";

export function Field({ label, ...props }) {
  return (
    <label className="block">
      <span className="text-[0.65rem] uppercase tracking-[0.14em] text-ptf-text/60">{label}</span>
      <input className={base + " mt-1"} {...props} />
    </label>
  );
}

export function TextArea({ label, ...props }) {
  return (
    <label className="block">
      <span className="text-[0.65rem] uppercase tracking-[0.14em] text-ptf-text/60">{label}</span>
      <textarea className={base + " mt-1 resize-none"} rows={3} {...props} />
    </label>
  );
}

export function SelectField({ label, options = [], ...props }) {
  return (
    <label className="block">
      <span className="text-[0.65rem] uppercase tracking-[0.14em] text-ptf-text/60">{label}</span>
      <select className={base + " mt-1"} {...props}>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  );
}

export function AdminButton({ children, variant = "primary", ...props }) {
  const cls = variant === "primary"
    ? "bg-ptf-primary text-ptf-bg hover:bg-ptf-secondary"
    : variant === "danger"
    ? "bg-red-600 text-white hover:bg-red-700"
    : "border border-ptf-primary/25 text-ptf-primary hover:bg-ptf-primary/5";
  return (
    <button className={`inline-flex items-center gap-2 px-5 py-2.5 text-[0.7rem] font-semibold uppercase tracking-[0.14em] transition-colors ${cls}`} {...props}>
      {children}
    </button>
  );
}
